export const ONBOARDING_STEPS = [
  {
    id: "01",
    title: "Step 1: Prepare for Compugrade.com",
    description: "Ensure your account is ready by reviewing system requirements and prerequisites.",
    buttonLabel: "View prerequisites",
  },
  {
    id: "02",
    title: "Step 2: Install the Auto-grader Add-in",
    description: "Install the tools you need for your courses. You'll be prompted based on your purchases.",
    buttonLabel: "Install for Microsoft Word",
  },
  {
    id: "03",
    title: "Step 3: Start Your First Class",
    description: "Create your first class and invite your students to begin learning.",
    buttonLabel: "View class setup guide",
  },
]

export const QUICK_ACCESS_CARDS = [
  {
    id: "manage-class-students",
    title: "Manage Classes, Students, and Assign Courses",
    path: "/classes",
    icon: "users",
  },
  {
    id: "manage-course-curriculum",
    title: "Manage Courses & Set Preferences",
    path: "/curriculum",
    icon: "book",
  },
  {
    id: "gradebook",
    title: "Gradebook",
    path: "/curriculum/gradebook",
    icon: "clipboard",
  },
  {
    id: "reports",
    title: "Reports",
    path: "/reports",
    icon: "file",
  },
  {
    id: "additional-resources",
    title: "Teacher Materials",
    path: "/resources",
    icon: "folder",
  },
]
